module.exports = __webpack_public_path__ + "img/gsb.8ddb2b37.png";